import { render, staticRenderFns } from "./PublicFilesView.vue?vue&type=template&id=13b7307e&scoped=true&"
import script from "./PublicFilesView.vue?vue&type=script&lang=js&"
export * from "./PublicFilesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b7307e",
  null
  
)

export default component.exports